const {
  ReactIcon: Icon
} = svs.ui;
export const InfoOmbudsnummer = () => <div className="terminal-nummer-info padding-1 f-content u-flex margin-bottom-2">
    <Icon icon="information" size="300" />
    <span className="margin-left">
      Tänk på att ditt ombudsnummer inte är samma som ditt terminalnummer.
    </span>
  </div>;